const wizardComponentsHelper = require('routes/contractsView/utilities/wizardComponenstHelper');
const inputs = require('routes/contractsView/fioc/inputs.js');

function buildEmployed(prefix, authorized = false) {
    const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc, prefix);
    let grid = [[inputsFioc.profession]];
    if (!authorized) {
        grid = [
            ...grid,
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionId1: prefix + 'fioc_profession',
                conditionType: 'ifPrevIsComplete',
                item: inputsFioc.company_name
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'company_name',
                item: [inputsFioc.incomes_annual]
            }],
        ];
    } else {
        grid = [
            ...grid,
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'fioc_sector',
                item: [
                    inputsFioc.profession_search,
                    inputsFioc.profession
                ]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'fioc_profession',
                item: inputsFioc.company_name
            }]
        ];
    }

    return {
        id_component: 'condition-show',
        id: 'show',
        conditionType: 'single',
        conditionId1: prefix + 'fioc_ocupation',
        conditionValue1: 1,
        item: {
            id_component: 'fioc',
            id: prefix + 'fioc_employed',
            exclude: [],
            grid
        }
    };
}

module.exports = buildEmployed;